/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import {
	getOrdersImportsListSelector,
	getIsOrdersImportsListLoadingSelector,
	getPaginationSelector,
} from './selectors';
import { getIsAvailableOrdersButtonsSelector } from '../profile/selectors';
import { getOrdersImportsListAction, resetStateAction } from './actions';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { DataGridComponent } from '../../components/data-grid';
import { PageContentWithNav } from '../../components/page-content-with-nav';
import { TABLE_ORDERS_IMPORTS_COLUMNS } from './constants';
import { getMenuByRules } from '../orders/utils';

const OrderImportsContainerWrapper = ({
	onGetOrdersImportsList,
	ordersImportsList,
	isOrdersImportsListLoading,
	pagination,
	onResetState,
	isAvailable,
}) => {
	useInjectSaga({ key: 'ordersImportsContainerSaga', saga });
	useInjectReducer({ key: 'ordersImportsContainerReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		onGetOrdersImportsList({ searchQuery: removeModalQuery(query.toString()) });

		return () => onResetState();
	}, []);

	const handlePageChange = (_, { activePage }) => {
		query.set('page', activePage);
		history.push(`${pathname}?${query}`);
		onGetOrdersImportsList({ searchQuery: removeModalQuery(query.toString()) });
	};

	const handleImportButtonClick = () => {
		query.set('modal', 'order');
		query.set('mode', 'import');

		history.push(`${pathname}?${query}`);
	};

	const handleSelectChange = (_, { value }) => {
		query.set('page', 1);
		if (value === 'all') {
			query.delete('per_page');
		} else {
			query.set('per_page', value);
		}
		history.push(`${pathname}?${query}`);
		onGetOrdersImportsList({ searchQuery: removeModalQuery(query.toString()) });
	};

	return (
		<PageContentWithNav
			pageNavigationItems={getMenuByRules()}
			isInnerRouter
			pageContent={
				<DataGridComponent
					headerText="Импорт"
					columns={TABLE_ORDERS_IMPORTS_COLUMNS}
					onImportButtonClick={isAvailable.create ? handleImportButtonClick : null}
					rows={ordersImportsList}
					pagination={
						!pagination
							? null
							: { ...pagination, onPageChange: handlePageChange, onSelectChange: handleSelectChange }
					}
					isTableDataLoading={isOrdersImportsListLoading}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	ordersImportsList: getOrdersImportsListSelector(),
	isOrdersImportsListLoading: getIsOrdersImportsListLoadingSelector(),
	pagination: getPaginationSelector(),
	isAvailable: getIsAvailableOrdersButtonsSelector(),
});

const mapDispatchToProps = {
	onGetOrdersImportsList: getOrdersImportsListAction,
	onResetState: resetStateAction,
};

const OrderImportsContainer = connect(mapStateToProps, mapDispatchToProps)(OrderImportsContainerWrapper);

OrderImportsContainerWrapper.propTypes = {
	onGetOrdersImportsList: PropTypes.func.isRequired,
	ordersImportsList: PropTypes.array.isRequired,
	isOrdersImportsListLoading: PropTypes.bool.isRequired,
	pagination: PropTypes.shape({
		currentPage: PropTypes.number,
		totalPages: PropTypes.number.isRequired,
		total: PropTypes.number,
		from: PropTypes.number,
		to: PropTypes.number,
		isNextItem: PropTypes.bool,
		isPrevItem: PropTypes.bool,
		isFirstItem: PropTypes.bool,
		isLastItem: PropTypes.bool,
	}),
	onResetState: PropTypes.func,
	isAvailable: PropTypes.objectOf(PropTypes.bool),
};

export default OrderImportsContainer;
